import { render, staticRenderFns } from "./userPrivacyProtocol.vue?vue&type=template&id=57d1c086&scoped=true"
import script from "./userPrivacyProtocol.vue?vue&type=script&lang=js"
export * from "./userPrivacyProtocol.vue?vue&type=script&lang=js"
import style0 from "./userPrivacyProtocol.vue?vue&type=style&index=0&id=57d1c086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d1c086",
  null
  
)

export default component.exports